import React from 'react';
import { FileBox } from './styles';
import { RenderFilePreview } from '../../renderFilePreview';
import { CommentFilesInterface } from '../../../interfaces/TaskInterface';

interface CommentFilePreviewProps {
  uploadedFiles: CommentFilesInterface[];
  onClickClose: (index: number, file: CommentFilesInterface) => void;
  disable?: boolean;
}

export const CommentFilePreview: React.FC<CommentFilePreviewProps> = React.memo(
  ({ uploadedFiles, onClickClose, disable }) => {
    if (disable || !uploadedFiles || uploadedFiles.length === 0) return null;

    return (
      <FileBox>
        {uploadedFiles.map((file: CommentFilesInterface, index: number) => {
          return (
            <RenderFilePreview
              key={file?.href}
              file={file}
              isClose={true}
              maxWidth={240}
              onClose={() => onClickClose(index, file)}
            />
          );
        })}
      </FileBox>
    );
  }
);
